import { render, staticRenderFns } from "./How_It_Works.vue?vue&type=template&id=1a72fcb2&scoped=true&"
import script from "./How_It_Works.vue?vue&type=script&lang=js&"
export * from "./How_It_Works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72fcb2",
  null
  
)

export default component.exports